import { AnimateIn, Button } from '../../shared/ui';
import { usePageMeta } from '../../shared/hooks/usePageMeta';

export function NotFoundPage() {
  usePageMeta('Page Not Found');

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#0a0a0a] text-white px-6 py-20">
      <AnimateIn animation="fade-up" className="mx-auto max-w-md text-center">
        <img src="/logo-white.png" alt="RT Equipment & Haulage" className="h-10 w-auto mx-auto mb-8" />
        <p className="text-accent text-sm font-bold tracking-widest uppercase mb-4">404</p>
        <h1 className="text-3xl sm:text-4xl font-black leading-tight tracking-tight mb-4">
          This page doesn't exist
        </h1>
        <p className="text-white/60 text-sm leading-relaxed mb-10">
          The link you followed may be broken, or the page may have been moved.
        </p>
        <div className="flex flex-col items-center gap-3">
          <Button to="/" variant="marketing-primary" size="lg">
            Back to home
          </Button>
          <Button to="/#contact" variant="ghost" size="md" className="!text-white/50 hover:!text-white">
            Contact us
          </Button>
        </div>
      </AnimateIn>
    </div>
  );
}
